import getDisplayName from './getDisplayName.js';

function createHocName(hocComponentName, WrappedComponent) {
  return `${hocComponentName}(${getDisplayName(WrappedComponent)})`;
}

export { createHocName as default };
//# sourceMappingURL=createHocName.js.map
